<div>
  <ng-container *ngIf="formControlItem; else noFormControl">
    <div>
      <ng-container *ngIf="label">
        <label [for]="id" class="{{labelClass}} block text-normal text-center text-sm font-medium leading-6">{{label | translate}}</label>
      </ng-container>
      <div class="relative mt-2 rounded-md shadow-sm">
        <ng-container *ngIf="iconPrefix">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <i [class]="iconPrefix"></i>
          </div>
        </ng-container>
        <input #currentElement [type]="type"
               [formControl]="formControlItem"
               [id]="id"
               [name]="id"
               autocomplete="off"
               (input)="valueChange($event)"
               (focusout)="focusOut($event)"
               [placeholder]="(placeholder || '') | translate"
               [disabled]="disabled"
               [min]="min"
               [max]="max"
               class="block text-normal font-medium p-3 w-full text-16 rounded-md border-none
                 ring-1 ring-inset ring-border focus:ring-2
                 focus:ring-inset focus:ring-transparent leading-6 bg-transparent"
               [ngClass]="customClasses">
        <ng-container *ngIf="iconSufix">
          <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <i [class]="iconSufix"></i>
          </div>
        </ng-container>
      </div>
      <ng-container>
        <app-validation-error [control]="formControlItem "  class="text-red-500 text-xs italic"></app-validation-error>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #noFormControl>
    <div>
      <ng-container *ngIf="label">
          <label [for]="id" class="{{labelClass}} block text-normal text-center text-sm font-medium leading-6">{{label | translate}}</label>
      </ng-container>
      <div class="relative mt-2 rounded-md shadow-sm">
        <ng-container *ngIf="iconPrefix">
          <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <i [class]="iconPrefix"></i>
          </div>
        </ng-container>
        <input #currentElement [type]="type"
               [id]="id"
               [value]="value"
               [name]="id"
               autocomplete="off"
               (input)="valueChange($event)"
               (blur)="onBlur()"
               [step]="step"
               [disabled]="disabled"
               class="block text-normal font-medium p-3 w-full text-16 rounded-md border-none
                 ring-1 ring-inset ring-gray-300 focus:ring-2
                 focus:ring-inset focus:ring-transparent leading-6 bg-transparent"
               [ngClass]="customClasses"
               [placeholder]="(placeholder || '') | translate">
      </div>
    </div>
  </ng-template>
</div>
